var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.868,
    height: 99.903,
    viewBox: "0 0 134.868 99.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4782.551 -3013.636)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4783.551 3053.087h113.64v55.249a4.2 4.2 0 01-4.2 4.2h-105.236a4.2 4.2 0 01-4.2-4.2v-68.987a4.2 4.2 0 014.2-4.2h90.209m-94.413 36.517h113.64",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.227,
    cy: 19.227,
    r: 19.227,
    transform: "translate(4877.964 3014.636)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4888 3040.942h15.663a4.842 4.842 0 004.843-4.843v-3.957m-1.722-5.357h-16.059a4.844 4.844 0 00-4.843 4.844v3.27",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4903.264 3023.817l3.521 2.968-2.968 3.521m-12.301 13.605l-3.521-2.969 2.968-3.521",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.004,
    cy: 10.004,
    r: 10.004,
    transform: "translate(4795.906 3081.277)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4830.183 3085.895h57.813m-57.813 5.386h57.813m-57.813 5.387h57.813"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentProvider);
export default __webpack_public_path__ + "static/media/paymentProvider.efd1053760da00dd931218be15b00a6a.svg";
export { ForwardRef as ReactComponent };